module.exports = __webpack_public_path__ + "media/goforajourney/img/barcelona/img504-7de545d642e48297c942f301db87c881.jpg";